module.exports = __webpack_public_path__ + "img/b3-2.6a2c3ee.png";